/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleFactOwnershipData
 */
export interface GoogleFactOwnershipData {
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipData
     */
    factFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipData
     */
    providerAccountKey?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipData
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipData
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipData
     */
    mode?: string;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFactOwnershipData
     */
    effectiveFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFactOwnershipData
     */
    effectiveUntil?: Date | null;
}

/**
 * Check if a given object implements the GoogleFactOwnershipData interface.
 */
export function instanceOfGoogleFactOwnershipData(value: object): value is GoogleFactOwnershipData {
    return true;
}

export function GoogleFactOwnershipDataFromJSON(json: any): GoogleFactOwnershipData {
    return GoogleFactOwnershipDataFromJSONTyped(json, false);
}

export function GoogleFactOwnershipDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleFactOwnershipData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'factFamily': json['factFamily'] == null ? undefined : json['factFamily'],
        'providerAccountKey': json['providerAccountKey'] == null ? undefined : json['providerAccountKey'],
        'source': json['source'] == null ? undefined : json['source'],
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'effectiveUntil': json['effectiveUntil'] === undefined ? undefined : json['effectiveUntil'] === null ? null : (new Date(json['effectiveUntil'])),
    };
}

export function GoogleFactOwnershipDataToJSON(json: any): GoogleFactOwnershipData {
    return GoogleFactOwnershipDataToJSONTyped(json, false);
}

export function GoogleFactOwnershipDataToJSONTyped(value?: GoogleFactOwnershipData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'factFamily': value['factFamily'],
        'providerAccountKey': value['providerAccountKey'],
        'source': value['source'],
        'integrationId': value['integrationId'],
        'mode': value['mode'],
        'effectiveFrom': value['effectiveFrom'] == null ? value['effectiveFrom'] : value['effectiveFrom'].toISOString().substring(0,10),
        'effectiveUntil': value['effectiveUntil'] == null ? value['effectiveUntil'] : value['effectiveUntil'].toISOString().substring(0,10),
    };
}

